module.exports = __webpack_public_path__ + "img/awards_money1.a5c42dfb.png";